// cf-aj0 : droits par section venus du serveur (/auth/me -> capabilities : section -> hidden | view | edit | spend).
// Le serveur refuse de toute façon (403 role_denied) : ici on cache ce qu'un rôle ne peut pas utiliser.
const LEVELS = ["hidden", "view", "edit", "spend"];

// sans capabilities (ancien serveur, réponse de connexion) : rien n'est caché
export function levelOf(user, section) {
  const caps = user?.capabilities;
  if (!caps) return "spend";
  return caps[section] || "hidden";
}

export function can(user, section, need = "view") {
  return LEVELS.indexOf(levelOf(user, section)) >= LEVELS.indexOf(need);
}

// un rôle qui ne dépense nulle part (réalisateur, commercial, invité) : boutons de génération masqués partout
export function canSpendAnywhere(user) {
  const caps = user?.capabilities;
  if (!caps) return true;
  return Object.values(caps).includes("spend");
}
